import React from "react";
import type { DealerAndId } from "./helper";
import type { UseTreeItemParameters } from "@dealer-center/core-components";
import {
  Box,
  TreeItemContent,
  TreeItemGroupTransition,
  TreeItemIcon,
  TreeItemIconContainer,
  TreeItemLabel,
  TreeItemProvider,
  TreeItemRoot,
  useTreeItem
} from "@dealer-center/core-components";
import { TreeItemAdditionalInfo } from "./treeItemAdditionalInfo";
import { treeItemStyles } from "./treeStyles";

export const CustomTreeItem = React.forwardRef(function CustomTreeItem(
  props: UseTreeItemParameters & { children?: React.ReactNode },
  ref: React.Ref<HTMLLIElement>
) {
  const { id, itemId, label, disabled: isDisabled, children, ...other } = props;

  const {
    getRootProps,
    getContentProps,
    getIconContainerProps,
    getLabelProps,
    getGroupTransitionProps,
    publicAPI,
    status
  } = useTreeItem({
    id,
    itemId,
    children,
    label,
    disabled: isDisabled,
    rootRef: ref
  });
  const dealer = publicAPI.getItem(itemId).dealer as DealerAndId;
  const isDisabledForReal =
    dealer.status !== "ACTIVE" && dealer.status !== "IN_PRODUCTION";
  return (
    <TreeItemProvider id={id} itemId={itemId}>
      <TreeItemRoot {...getRootProps(other)}>
        <TreeItemContent
          {...getContentProps()}
          status={{
            ...getContentProps().status,
            disabled: isDisabledForReal
          }}
        >
          <TreeItemIconContainer {...getIconContainerProps()}>
            <TreeItemIcon status={status} />
          </TreeItemIconContainer>
          <Box sx={treeItemStyles.itemAreaSX}>
            <TreeItemLabel
              {...getLabelProps()}
              sx={treeItemStyles.itemTitleSX}
            />
            <Box sx={treeItemStyles.itemDetailsSX}>
              <TreeItemAdditionalInfo
                dealer={dealer}
                label={getLabelProps().children as string}
              />
            </Box>
          </Box>
        </TreeItemContent>
        {children && (
          <TreeItemGroupTransition
            {...getGroupTransitionProps()}
            sx={treeItemStyles.CustomTreeItemGroupTransition}
          />
        )}
      </TreeItemRoot>
    </TreeItemProvider>
  );
});
